import { useRef } from 'react';

export default function useWait() {
  const timeoutId = useRef();

  const wait = (delay) =>
    new Promise((resolve, reject) => {
      timeoutId.current = setTimeout(() => {
        timeoutId.current = null;
        resolve();
      }, delay);
    });

  const cancelWait = () => {
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
      timeoutId.current = null;
    }
  };

  return { wait, cancelWait };
}
